export default "/images/cart.svg?b8203702f59394ae9853629a4c5b2278";